<template>
  <v-layout>
    <v-flex xs12>
      <app-loader
        title="Загрузка данных Поставки на складе"
        :loading="loading"
      />
      <v-card
        v-show="!loading"
        class="mt-1 mb-0 mx-0 pa-2"
        :style="{ height: blockHeight + 'px' }"
      >
        <v-card-title class="pa-2">
          <h2 class="title py-0 px-2">
            Поставки на складе
          </h2>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Поиск"
            outline
            single-line
            hide-details
          />

          <DataColumnsSettings
            :columns="columns"
            resource="warehouseDetails"
            :settings-button-style="{
              flat: true,
              colorButton: '',
              colorIcon: 'grey'
            }"
          />
        </v-card-title>
        <ShippingPhasesInWarehouse :items-loading="loading" />
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import ShippingPhasesInWarehouse from "./components/ShippingPhasesInWarehouse.vue";
import DataColumnsSettings from "../../components/data-list/ColumnsSettings.vue";

export default {
  components: {
    ShippingPhasesInWarehouse,
    DataColumnsSettings,
  },
  data() {
    return {
      search: "",
      loading: false,
    };
  },
  computed: {
    headers() {
      return this.$store.getters["warehouseDetails/headers"];
    },
    columns() {
      const columns = JSON.parse(JSON.stringify(this.headers));
      columns.forEach(c => {
        c.visible = true;
        c.order = 0;
      });
      return columns.filter(c => c.title && c.type !== "icon");
    },
    blockHeight() {
      return window.innerHeight - 46;
    },
  },
  created() {
    this.getItems();
  },
  methods: {
    async getItems() {
      this.loading = true;
      await this.$store.dispatch("warehouseDetails/getData");
      this.loading = false;
    },
  },
};
</script>
